import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '../../components/ModalComponent';

const PaymentRequiredPage = () => {
  const Navigate = useNavigate();
  const [showIncompletePaymentModal, setShowIncompletePaymentModal] = useState(true);

  const handleIncompletePaymentModal = () => {
    setShowIncompletePaymentModal(!showIncompletePaymentModal);
    Navigate('/my-account/plans');
  };

  return (
    <div>
      <ModalComponent
        title="サブスクリプションの確認"
        body={(
          <div>
            <div>サブスクリプションの有効期限が切れています</div>
          </div>
        )}
        centered
        animation={false}
        show={showIncompletePaymentModal}
        onConfirm={handleIncompletePaymentModal}
        closeModal={handleIncompletePaymentModal}
        cancelButtonText="プラン変更へ"
        hideConfirmButton
      />
    </div>
  );
};

export default PaymentRequiredPage;
